import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-scroll-top-button',
  templateUrl: './scroll-top-button.component.html',
  styleUrls: ['./scroll-top-button.component.scss'],
})
export class ScrollTopButtonComponent implements OnInit {
  faAngleUp = faAngleUp;
  windowScrolled: boolean = false;

  constructor(@Inject(DOCUMENT) private DOCUMENT: Document) {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // console.log(document.documentElement.scrollTop);
    if (document.documentElement.scrollTop > 800) {
      this.windowScrolled = true;
    } else {
      this.windowScrolled = false;
    }
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, 0);
      }
    })();
  }

  ngOnInit(): void {}
}
